export default __webpack_public_path__ + "static/media/logo.56dea381.svg";